import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { EmpresasService } from "../../../catalogs/empresas/empresas.service";
import { TiposUnidadService } from "../../../catalogs/tipos-unidades/tipos-unidades.service";
import * as dayjs from "dayjs";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListColumn } from "src/app/models/list-columns.model";
import { ElementRef } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-modal-poliza",
  templateUrl: "./modal-poliza.component.html",
})
export class PolizaModal implements OnInit {
  @ViewChild("polizaInput", { static: false })
  public polizaInput: ElementRef;

  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();
  polizaImg: string = "";
  polizaFile: File = undefined;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PolizaModal>
  ) {}

  public ngOnInit() {
    this.buildForm();
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      Vigencia: [new Date()],
    });
  }
  OpenPolizaSelect() {
    this.polizaInput.nativeElement.click();
  }

  public getPoliza(polizaInput: any) {
    if (polizaInput.files.length > 0) {
      Array.from(polizaInput.files).forEach(async (file) => {
        await this.processPoliza(file as File);
      });
    }
  }

  processPoliza(file: File) {
    const reader: FileReader = new FileReader();
    if (file.type == "application/pdf") {
      this.polizaImg =
        "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg";
      this.polizaFile = file;
      return;
    }

    const promise: Promise<void> = new Promise((resolve) => {
      reader.onload = () => {
        this.polizaImg = reader.result as string;
        this.polizaFile = file;
        resolve();
      };
      reader.readAsDataURL(file);
    });
    return promise;
  }

  async fileFromDataUrl(dataURL) {
    const blob = await (await fetch(dataURL)).blob();
    const file = new File([blob], "fileName.jpg", {
      type: "image/jpeg",
      lastModified: new Date().getTime(),
    });
    return file;
  }

  save() {
    const data = this.form.value;
    this.dialogRef.close({
      ...data,
      poliza: this.polizaFile,
    });
  }
}
